'use strict';
import * as $j_app$002edata$002e$002dForm$002dQuantity$0024given$005f$002dExtract$005f$002dForm$002dQuantity$0024 from "./app.data.-Form-Quantity$given_-Extract_-Form-Quantity$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PurchaseOrderLineItemForm(name, unitPrice, quantity, quantityUnit, grossWeight, netWeight, referenceNumber) {
  this.aFu = null;
  this.nr = null;
  this.lT = null;
  this.mN = null;
  this.mO = null;
  this.lQ = null;
  this.lR = null;
  this.lS = null;
  this.nr = name;
  this.lT = unitPrice;
  this.mN = quantity;
  this.mO = quantityUnit;
  this.lQ = grossWeight;
  this.lR = netWeight;
  this.lS = referenceNumber;
  this.aFu = $j_app$002edata$002e$002dForm$002dQuantity$0024given$005f$002dExtract$005f$002dForm$002dQuantity$0024.$m_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$();
}
export { $c_Lapp_data_PurchaseOrderLineItemForm as $c_Lapp_data_PurchaseOrderLineItemForm };
$p = $c_Lapp_data_PurchaseOrderLineItemForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PurchaseOrderLineItemForm;
/** @constructor */
function $h_Lapp_data_PurchaseOrderLineItemForm() {
}
export { $h_Lapp_data_PurchaseOrderLineItemForm as $h_Lapp_data_PurchaseOrderLineItemForm };
$h_Lapp_data_PurchaseOrderLineItemForm.prototype = $p;
$p.IB = (function() {
  return this.aFu;
});
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_PurchaseOrderLineItemForm)) {
    if ((this.nr === x$0.nr)) {
      var x = this.lT;
      var x$2 = x$0.lT;
      var $x_4 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.mN;
      var x$4 = x$0.mN;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.mO === x$0.mO))) {
      var x$5 = this.lQ;
      var x$6 = x$0.lQ;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.lR;
      var x$8 = x$0.lR;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.lS;
      var x$10 = x$0.lS;
      return ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 7;
});
$p.t = (function() {
  return "PurchaseOrderLineItemForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.nr;
      break;
    }
    case 1: {
      return this.lT;
      break;
    }
    case 2: {
      return this.mN;
      break;
    }
    case 3: {
      return this.mO;
      break;
    }
    case 4: {
      return this.lQ;
      break;
    }
    case 5: {
      return this.lR;
      break;
    }
    case 6: {
      return this.lS;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "unitPrice";
      break;
    }
    case 2: {
      return "quantity";
      break;
    }
    case 3: {
      return "quantityUnit";
      break;
    }
    case 4: {
      return "grossWeight";
      break;
    }
    case 5: {
      return "netWeight";
      break;
    }
    case 6: {
      return "referenceNumber";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Kb = (function() {
  return this.lT;
});
$p.Es = (function() {
  return this.mN;
});
$p.agr = (function() {
  return this.mO;
});
$p.a5q = (function() {
  return this.lQ;
});
$p.a5O = (function() {
  return this.lR;
});
function $isArrayOf_Lapp_data_PurchaseOrderLineItemForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jS)));
}
export { $isArrayOf_Lapp_data_PurchaseOrderLineItemForm as $isArrayOf_Lapp_data_PurchaseOrderLineItemForm };
var $d_Lapp_data_PurchaseOrderLineItemForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PurchaseOrderLineItemForm, "app.data.PurchaseOrderLineItemForm", ({
  jS: 1,
  eC: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_PurchaseOrderLineItemForm as $d_Lapp_data_PurchaseOrderLineItemForm };
//# sourceMappingURL=app.data.-Purchase-Order-Line-Item-Form.js.map
